export const GLOBLE_OBJECT = 'GLOBLE_OBJECT';
export const GIFT_LIST_HEADER = 'GIFT_LIST_HEADER'

export function isGlobleObjectLoaded(globalState) {
  return globalState.GlobleObject && globalState.GlobleObject.loaded;
}

export function getGlobleObject() {
  return {
    type: GLOBLE_OBJECT,
    promise: client => client.get('/api/labels'), // params not used, just shown as demonstration
  };
}

export const updateGiftListHeader = (type) =>  (dispatch, getState) => {
 dispatch({
    type: GIFT_LIST_HEADER,
    data: type,
  });
}
